import React from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { Archive, CheckCircle, Icon, SquaresFour, User } from 'phosphor-react';

import { IContagemContratos } from '../../../../hooks/useSocietario';
import { AbaDaListagem, ABAS_DA_LISTAGEM, ROTULOS_DAS_ABAS } from '../listagem';

const ICONES_DAS_ABAS: Record<AbaDaListagem, Icon> = {
  todos: SquaresFour,
  minhas: User,
  finalizados: CheckCircle,
  arquivados: Archive,
};

interface AbasDaListagemProps {
  aba: AbaDaListagem;
  onTrocar: (aba: AbaDaListagem) => void;
  /** Sem contagem (carregando ou falhou), as abas ficam sem número. */
  contagem?: IContagemContratos;
}

// Controle segmentado igual ao dos outros submódulos (Estatutos, Legalização): trilho
// cinza, aba ativa em branco com a cor do módulo.
export const AbasDaListagem: React.FC<AbasDaListagemProps> = ({ aba, onTrocar, contagem }) => (
  <Flex
    role="tablist"
    aria-label="Recorte da listagem"
    bg="gray.100"
    borderRadius="lg"
    p={1}
    gap={1}
    w="fit-content"
    maxW="100%"
    // Quebra em vez de rolar: no celular, rolando, "Finalizados" e "Arquivados"
    // ficavam fora da tela sem nenhum sinal de que existiam.
    flexWrap="wrap"
  >
    {ABAS_DA_LISTAGEM.map(chave => {
      const ativa = aba === chave;
      const IconeDaAba = ICONES_DAS_ABAS[chave];
      return (
        <Button
          key={chave}
          role="tab"
          aria-selected={ativa}
          size="sm"
          h="32px"
          px={3}
          flexShrink={0}
          variant="ghost"
          bg={ativa ? 'white' : 'transparent'}
          color={ativa ? 'blue.600' : 'gray.500'}
          boxShadow={ativa ? 'sm' : 'none'}
          fontWeight={ativa ? '700' : '600'}
          fontSize="sm"
          leftIcon={<IconeDaAba size={14} weight={ativa ? 'fill' : 'regular'} />}
          _hover={{ bg: ativa ? 'white' : 'gray.50' }}
          onClick={() => onTrocar(chave)}
        >
          {ROTULOS_DAS_ABAS[chave]}
          {contagem && (
            <Box
              as="span"
              ml={2}
              px={1.5}
              minW="20px"
              lineHeight="18px"
              borderRadius="full"
              fontSize="11px"
              fontWeight="700"
              textAlign="center"
              bg={ativa ? 'blue.50' : 'gray.200'}
              color={ativa ? 'blue.600' : 'gray.600'}
            >
              {contagem[chave]}
            </Box>
          )}
        </Button>
      );
    })}
  </Flex>
);

export default AbasDaListagem;
